import React from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';

interface InputFieldProps {
  label?: string; // optional
  placeholder?: string;
  register: UseFormRegisterReturn;
  error?: FieldError;
  type?: string;
  defaultValue?: string | number,
  step?: string
  readOnly?: boolean,
  isMinOne?: boolean
  containerClassName?: string;
  labelClassName?: string;
  inputClassName?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  placeholder,
  register,
  error,
  defaultValue,
  type = "text",
  step,
  readOnly = false,
  isMinOne = true,
  containerClassName = "",
  labelClassName = "",
  inputClassName = "",
}) => {
  return (
    <div className={`flex flex-col gap-1.5 ${containerClassName}`.trim()}>
      {label && (
        <label className={`text-[13px] font-semibold text-gray-500 capitalize ml-1 ${labelClassName}`.trim()}>
          {label}
        </label>
      )}
      <input
        autoComplete="off"
        type={type}
        min={0}
        placeholder={placeholder}
        defaultValue={defaultValue}
        step={step}
        readOnly={readOnly}
        {...register}
        className={`
          w-full rounded-xl border bg-white px-5 py-3.5 text-[14px] text-Black
          placeholder:text-gray-300 transition-all duration-200
          hover:border-gray-300
          ${error 
            ? 'border-danger focus:ring-danger/10 focus:border-danger' 
            : 'border-gray-200 focus:ring-primary/10 focus:border-primary'
          } 
          focus:outline-none focus:ring-4
          ${readOnly ? 'bg-gray-50 cursor-not-allowed opacity-75' : ''}
          ${inputClassName}
        `.trim()}
      />
      {error && <span className="text-danger text-[12px] mt-1 ml-1 font-medium">{error.message}</span>}
    </div>
  );
};

export default InputField;
